import React from 'react';
import { observer } from 'mobx-react-lite';
import { Formik } from 'formik';
import { toJS } from 'mobx';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { useTranslation } from 'react-i18next';
import { Form } from 'reactstrap';

import { useStore } from '../../../store';
import ContactFieldButton from '../../../components/ContactFieldButton/index';
import '../../../components/FormComponents/styles.scss';
import TextFieldFormGroup from './TextFieldFormGroup';

import '../styles.scss';

import { END_USERS_ROLE } from '../../../utils/constants';

const LoginInformationForm = observer(({ togglePhone, toggleEmail }) => {
  const {
    rootStore: { profileStore },
  } = useStore();
  const { t } = useTranslation();

  const isEndUser = profileStore.connection === END_USERS_ROLE;
  const initialData = toJS(profileStore.profileData);

  const initialEmailValues = { email: initialData.email };
  const initialPhoneValues = { phone: initialData.phone };

  const handlePhoneBlur = (event, setFieldValue, handleBlur) => {
    const phone = parsePhoneNumberFromString(event.target.value, 'CH');
    if (phone) {
      setFieldValue('phone', phone.number);
    }
    handleBlur(event);
  };

  const onEmailSubmit = (values, { setSubmitting, resetForm }) => {
    profileStore.contactStore.sendEmailVerification(values).then(result => {
      if (result) {
        toggleEmail();
        resetForm(initialEmailValues);
      }
      setSubmitting(false);
    });
  };

  const onPhoneSubmit = (values, { setSubmitting, resetForm }) => {
    profileStore.contactStore.sendPhoneVerification(values).then(result => {
      if (result) {
        togglePhone();
        resetForm(initialPhoneValues);
      }
      setSubmitting(false);
    });
  };

  if (!initialData) {
    return null;
  }

  return (
    <>
      <Formik
        initialValues={initialEmailValues}
        validateOnChange
        enableReinitialize
        validate={values => {
          return profileStore.contactStore.validateEmail(values, t);
        }}
        onSubmit={onEmailSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldTouched,
          /* and other goodies */
        }) => (
          <Form className="styled-form" onSubmit={handleSubmit}>
            <TextFieldFormGroup
              type="email"
              name="email"
              id="email-current"
              placeholder={t('email.placeholder')}
              handleChange={handleChange}
              handleBlur={handleBlur}
              onInput={() => setFieldTouched('email', true, true)}
              values={values}
              errors={errors}
              touched={touched}
              label={t('email.label')}
            />
            {!errors.email && touched.email && initialData.email !== values.email ? (
              <div className="profile-button-container email">
                <ContactFieldButton type="submit">{t('contact.saveVerify')}</ContactFieldButton>
              </div>
            ) : null}
          </Form>
        )}
      </Formik>
      {!isEndUser && (
        <Formik
          initialValues={initialPhoneValues}
          enableReinitialize
          validate={values => {
            return profileStore.contactStore.validatePhone(values, t);
          }}
          onSubmit={onPhoneSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
            /* and other goodies */
          }) => (
            <Form onSubmit={handleSubmit} className="d-flex flex-column styled-form">
              <TextFieldFormGroup
                type="text"
                name="phone"
                id="phone-current"
                placeholder={t('phone.placeholder')}
                handleChange={handleChange}
                handleBlur={event => handlePhoneBlur(event, setFieldValue, handleBlur)}
                onInput={() => setFieldTouched('phone', true, true)}
                values={values}
                errors={errors}
                touched={touched}
                label={t('phone.label')}
              />
              {!errors.phone && touched.phone && initialData.phone !== values.phone ? (
                <div className="profile-button-container">
                  <ContactFieldButton type="submit">{t('contact.saveVerify')}</ContactFieldButton>
                </div>
              ) : null}
            </Form>
          )}
        </Formik>
      )}
    </>
  );
});

export default LoginInformationForm;
